module.exports = __webpack_public_path__ + "static/assets/800f6f1573677d59954e8d3164602287.svg";